import styled from "styled-components";

export const HeaderButton = styled.button`
  display: flex;
  align-items: center;
  gap: var(--sm);

  background: transparent;
  color: white;
  text-decoration: none;
  padding: 2px 3px;
  border-radius: 5px;
  border: 0;
  font-size: 12px;
  font-weight: 300;
  transition: background-color 300ms ease-out;

  &:focus,
  &:hover {
    background: var(--bismark);
    text-decoration: none;
  }

  span.spacer {
    height: 25px;
  }

  span:nth-child(2) {
    border: 1px solid #fff;
    border-radius: 25px;
    display: inline-block;
    height: 25px;
    margin-right: 8px;
    width: 25px;
  }

  &.active {
    background: var(--bismark);
    text-decoration: none;
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;

    > div {
      margin-bottom: calc(var(--small-spacing) + 1px);
    }
  }
`;
